// ============================================================================
// Kill-switch prep for un-metered, browser-called Cloud Functions — CW-006.
// ----------------------------------------------------------------------------
// Background: the sources for these Cloud Functions are unlocated, and the
// probable owner (Arnab) has not yet been asked about them. The release gate
// requires them DISABLED before release. This file PREPARES that disable:
// flipping the single flag below to `false` cuts every live browser entry
// point, and nothing in this patch changes behavior today (default is `true`,
// preserving today's rendering byte-for-byte).
//
// Functions protected by CW_UNMETERED_PROVIDERS_ENABLED:
//   - add-speaker-labels-stream — SSE speaker-label streaming ("Refine with
//     AI", REACT_APP_STREAM_BACKEND_URL). Gate sites:
//     MedicalScribeTranscription.js "Refine with AI" button;
//     MedicalScribeTranscriptionData.js applyStreamingSpeakerLabels().
//   - medical-icd-codes — suggested-ICD generation (TikcareAssistantService
//     POST /medical-icd-codes). Gate sites: MedicalCoding.js "Suggested"
//     refresh button; MedicalScribeTranscriptionData.js saveSuggestedCodes().
//   - medical-scribe-get-chief-complaint — NOT gated: dead code on this base
//     (medicalScribeGetChiefComplaint has no caller anywhere under src/), so
//     the browser cannot reach it today. If a caller is ever added, gate that
//     call site behind this flag in the same commit.
//
// Independent of PHASE45_COMMS_ENABLED (see constants/phase45Comms.js — that
// flag controls Phase 4/5 wallet-comms copy; this one controls Cloud Function
// kill switches). The two flags must never be coupled: flipping one does not
// affect the other.
//
// NOT gated, on purpose: the free NIH ICD search UI
// (clinicaltables.nlm.nih.gov, MedicalCoding.js) is not a Cloud Function here
// and must keep working whichever way this flag reads.
// ============================================================================

// Single kill-switch for the two live un-metered Cloud Functions above.
// Default `true` = today's behavior, exactly. Flip to `false` the moment the
// release gate demands the disable (after the CW-006 owner-ask resolves).
export const CW_UNMETERED_PROVIDERS_ENABLED = true;
